import { useState } from "react";
import "./AdminParceiros.css";
import AdminEditarParceiro from "./AdmiEditarParceiro/AdminEditarParceiro";
import AdminCriarParceiro from "./AdminCriarParceiro/AdminCriarParceiro";

function AdminParceiros({
    marcas,
    setMarcas,
    localizacao,
    onClose
}) {
    const [loadingId, setLoadingId] = useState(null);
    const [parceiroEditando, setParceiroEditando] = useState(null);
    const [abrirCriar, setAbrirCriar] = useState(false);

    const parceiros = marcas.filter(
        m => m.localizacao === localizacao
    );

    const handleExcluir = async (id) => {
        const confirmar = window.confirm(
            "Deseja realmente excluir este parceiro?"
        );

        if (!confirmar) return;

        try {
            setLoadingId(id);

            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/marcas/deletar",
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ id }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "Erro ao excluir parceiro"
                );
            }

            setMarcas((prev) =>
                prev.filter((item) => item.id !== id)
            );
        } catch (error) {
            alert(error.message);
        } finally {
            setLoadingId(null);
        }
    };

    return (
        <div
            className="admin-parceiros-overlay"
            onClick={onClose}
        >
            <div
                className="admin-parceiros"
                onClick={(e) => e.stopPropagation()}
            >
                <h3>Parceiros</h3>

                <div className="admin-parceiros-topo">
                    <button
                        className="btn-criar-parceiro"
                        onClick={() => setAbrirCriar(true)}
                    >
                        Nova Marca/Parceiro
                    </button>
                </div>

                {parceiros.map((parceiro) => (
                    <div
                        key={parceiro.id}
                        className="admin-parceiro-item"
                    >
                        <div className="admin-parceiro-info">
                            <img
                                src={parceiro.imagem}
                                alt={parceiro.nome}
                            />

                            <div>
                                <strong>{parceiro.nome}</strong>
                            </div>
                        </div>

                        <div className="admin-parceiro-acoes">
                            <button
                                className="btn-editar-parceiro"
                                onClick={() => setParceiroEditando(parceiro)}
                            >
                                Editar
                            </button>

                            <button
                                className="admin-parceiro-delete"
                                onClick={() =>
                                    handleExcluir(parceiro.id)
                                }
                                disabled={loadingId === parceiro.id}
                            >
                                {loadingId === parceiro.id
                                    ? "..."
                                    : "✕"}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            {parceiroEditando && (
                <AdminEditarParceiro
                    parceiro={parceiroEditando}
                    onClose={() => setParceiroEditando(null)}
                    onSalvar={(parceiroAtualizado) => {
                        setMarcas(prev =>
                            prev.map(item =>
                                item.id === parceiroAtualizado.id
                                    ? parceiroAtualizado
                                    : item
                            )
                        );

                        setParceiroEditando(null);
                    }}


                />
            )}

            {abrirCriar && (
                <AdminCriarParceiro
                    localizacao={localizacao}
                    setMarcas={setMarcas}
                    onClose={() => setAbrirCriar(false)}
                />
            )}
        </div>
    );
}

export default AdminParceiros;